import { styled } from '@mui/material/styles';

import data from './data.json';

const BoxContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '40%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  background: theme.palette.common.white,
  borderRadius: '12px',
  marginTop: theme.spacing(2),
  padding: theme.spacing(4),
  [theme.breakpoints.down('xl')]: {
    width: '55%',
  },
  [theme.breakpoints.down('lg')]: {
    width: '60%',
  },
  [theme.breakpoints.down('md')]: {
    width: '80%',
  },
  [theme.breakpoints.down('sm')]: {
    width: '90%',
  },
  [theme.breakpoints.up('sm')]: {
    textAlign: 'center',
  },
}));

const Title = styled('p')(({ theme }) => ({
  fontWeight: 700,
  fontSize: '1.625rem',
  width: '80%',
  paddingBottom: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    fontSize: '1.5rem',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.375rem',
    width: '100%',
  },
}));

const ItemsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '80%',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

const Item = styled('li')(({ theme }) => ({
  marginBottom: theme.spacing(0.5),
}));

const RulesText = styled('p')(({ theme }) => ({
  color: '#354661',
  fontSize: '22px',
  [theme.breakpoints.down('md')]: {
    fontSize: '1rem',
  },
}));

const Description2Component = () => {
  return (
    <BoxContainer>
      <Title className="typography-v1-body1">
        Hvilken type gjeld nedbetales dersom jeg er heldig og vinner?
      </Title>
      <ItemsContainer>
        {data.rules.map((text) => (
          <Item key={text.index}>
            <RulesText className="typography-v1-legacy-p1">{text.text}</RulesText>
          </Item>
        ))}
      </ItemsContainer>
    </BoxContainer>
  );
};

export default Description2Component;
